const queryShadowAll = (selector: string, root: ParentNode = document): Element[] => {
  const results: Element[] = [];

  const traverse = (node: ParentNode): void => {
    node.querySelectorAll('*').forEach(el => {
      if (el.matches(selector)) results.push(el);
      if (el.shadowRoot) traverse(el.shadowRoot);
    });
  };

  traverse(root);

  return results;
};

const applyBestMatchSubtitleStyles = (): void => {
  queryShadowAll('.subtitle').forEach(el => {
    if (!(el instanceof HTMLElement)) return;
    if (el.textContent?.trim() !== 'Best Match') return;
    if (el.dataset.cxAgentBestMatchStyled) return;

    el.style.backgroundColor = '#1F843A';
    el.style.color = '#fff';
    el.style.padding = '4px 8px';
    el.style.borderRadius = '6px';
    el.style.alignSelf = 'flex-start';
    el.style.fontWeight = '500';
    el.dataset.cxAgentBestMatchStyled = '1';
  });
};

export const setupBestMatchSubtitleObserver = (): () => void => {
  let observer: MutationObserver | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const scheduleApply = (): void => {
    if (timeoutId !== null) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      applyBestMatchSubtitleStyles();
    }, 100);
  };

  const onMessageListLoaded = (): void => {
    const [ msgList ] = queryShadowAll('chat-messenger-message-list');
    if (!msgList?.shadowRoot) return;
    scheduleApply();
    observer?.disconnect();
    observer = new MutationObserver(scheduleApply);
    observer.observe(msgList.shadowRoot, { childList: true, subtree: true });
  };

  window.addEventListener('chat-messenger-message-list-loaded', onMessageListLoaded);

  return (): void => {
    window.removeEventListener('chat-messenger-message-list-loaded', onMessageListLoaded);
    observer?.disconnect();
    observer = null;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
};
